/**
 * Guardar y abrir archivos desde la app. En el iPad, «download» sobre un Blob abre la hoja de
 * compartir o guarda en Archivos; en Android y en el portátil, descarga directamente.
 */
export function downloadText(filename: string, text: string, mime = 'text/plain'): void {
  const url = URL.createObjectURL(new Blob([text], { type: `${mime};charset=utf-8` }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
  // Safari necesita un momento antes de poder soltar la dirección.
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}

export async function readFileText(file: File): Promise<string> {
  return file.text()
}
